console.log('js/banner.js -> v0.1.0');

$(function() {
    $(document).mousedown(function(e) {

        if ( $( ".cc-window" ).length && $( ".cc-window" ).is(':visible') ) {
            var container = $(".cc-window");

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) 
            {
                $(".cc-window .cc-dismiss")[0].click();
            }
        }
        
    });
});
